import { isProd } from '@sagano/agent/utils/env';
import { LayoutHeader } from '@sagano/share/components';
import User from './User';

const Header: React.FC = () => {
  const refresh = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    sessionStorage.clear();
    window.location.replace(e.currentTarget.href);
  };
  return (
    <LayoutHeader
      webTitle="Sagano Agent"
      refreshHandle={refresh}
      isProd={isProd}
    >
      <User />
    </LayoutHeader>
  );
};

export default Header;
